"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maybeGetComputedStyle = void 0;

var maybeGetComputedStyle = function () {
  var prevNode;
  var prevStyles;
  return function (win, element) {
    if (prevNode !== element) {
      prevNode = element;

      try {
        prevStyles = win.getComputedStyle(element);
      } catch (e) {
        console.warn(e);
        return false;
      }
    }

    return prevStyles;
  };
}();

exports.maybeGetComputedStyle = maybeGetComputedStyle;